import { Button, ButtonGroup, Col, Row } from "reactstrap";
import "./OverviewUserPage.css";
import "../GlobalStyles.css";
import 'bootstrap/dist/css/bootstrap.css';
import { useHistory } from "react-router";
import UserHeaderComponent from "../UserHeaderComponent";
import useWindowHeight from "../../Hooks/useWindowHeight";
import { EvStationFill } from 'react-bootstrap-icons';
import { useMsal } from "@azure/msal-react"; // User authentication + fetching user
import GraphService from '../../Services/GraphService'; //Service voor user data
import DriverService from "../../Services/DriverService"; //Service voor bestuurder data
import EmployeeService from "../../Services/EmployeeService"; //Service voor medewerker data
import Driver from "../../Models/Driver";
import EmployeeFamily from "../../Models/EmployeeFamily";
import { useMemo, useState, useEffect } from "react";
import MoonLoader from "react-spinners/MoonLoader";
import { css } from "@emotion/react";
import { toast } from "react-toastify";

export default function OverviewUserPage() {
    const { windowHeight } = useWindowHeight();

    const history = useHistory();

    const {instance} = useMsal();
    const employeeService = useMemo(() => new EmployeeService(instance), [instance]);
    const driverService = useMemo(() => new DriverService(instance), [instance]);
    const graphService = useMemo(() => new GraphService(instance), [instance]);

    const [driver, setDriver] = useState<Driver>();
    const [isLoading, setIsLoading] = useState(false);

    function getButtonDiv() {
        return (
            <>
                <ButtonGroup className="fixed-bottom navbar p-0">
                    <Button className="p-3 buttons-footer" style={{ backgroundColor: "#2F5FA1" }} onClick={() => history.push("/overview")}>
                        <i className="fas fa-arrow-left fa-2x"></i>
                    </Button>
                </ButtonGroup>
            </>
        );
    }

    useEffect(() =>{
        fetchCompanyCarData();
        
    },[])

    async function fetchCompanyCarData(){
        let user = await graphService.getUserDetails();
        let userName = user?.userPrincipalName as string;
        if (userName === null) {
            toast.error(`Kan geen gebruiker vinden.`);
            goBackToOverViewApp();
        }

        setIsLoading(true);

        employeeService.getEmployeeFamilyByUserName(userName).then((data: EmployeeFamily) => {
            if (!data) {
                toast.error(`Kan geen gebruiker met de gebruikersnaam ${userName} vinden.`);
                goBackToOverViewApp();
            } 
            return data;
        }).then((data: EmployeeFamily) => {
            driverService.getDriverByEmployeeContactId(data.contactId).then((driver: Driver) => {
                setDriver(driver);
                
            }).finally(() => {
                setIsLoading(false);
            });
        }).catch(() => {
            setIsLoading(false);
        });
    }

    
    function goBackToOverViewApp(): void {
        history.push("/overview");
    }

    

    function getLoadSpinner() {
        return (
            <MoonLoader
                color="black"
                loading={!driver || isLoading}
                css={
                    css`
                    display: block;
                    position: absolute;
                    left: calc(50% - 18px);
                    top: 125px; 
                    z-index: 1000`
                }
                size={25} />
        );
    }

    function getContent() {
        return (
          <>
          {driver && 
          <div style={{ height: `calc(${windowHeight}px - 185px)`, overflowY: "auto", overflowX: "hidden", maxHeight: "-webkit-fill-available" }}>
          <Row className="mx-auto p-3 mb-3 mt-3 button-row background-color-blue" onClick={() => history.push("/user-general-info")}>
              <Col xs="10" className="mx-auto d-flex align-items-center">
                  <h5 className="m-0">Algemene info</h5>
              </Col>
              <Col xs="2" className="d-flex justify-content-center">
                  <i className="fas fa-info-circle fa-2x"></i>
              </Col>
          </Row>
          <Row className="mx-auto p-3 mb-3 button-row background-color-blue" onClick={() => history.push("/user-family")}>
              <Col xs="10" className="mx-auto d-flex align-items-center">
                  <h5 className="m-0">Gezin</h5>
              </Col>
              <Col xs="2" className="d-flex justify-content-center">
                  <i className="fas fa-users fa-2x"></i>
              </Col>
          </Row>
          <Row className="mx-auto p-3 mb-3 button-row background-color-blue" onClick={() => history.push("/user-contracts")}>
              <Col xs="10" className="mx-auto d-flex align-items-center">
                  <h5 className="m-0">Contract gegevens</h5>
              </Col>
              <Col xs="2" className="d-flex justify-content-center">
                  <i className="fas fa-file-alt fa-2x"></i>
              </Col>
          </Row>
          <Row className="mx-auto p-3 mb-3 button-row background-color-blue" onClick={() => history.push("/user-companycar")}>
              <Col xs="10" className="mx-auto d-flex align-items-center">
                  <h5 className="m-0">Bedrijfswagen</h5>
              </Col>
              <Col xs="2" className="d-flex justify-content-center">
                  <i className="fas fa-car fa-2x"></i>
              </Col>
          </Row>
          <Row className="mx-auto p-3 mb-3 button-row background-color-blue" onClick={() => history.push("/user-fuelcard")}>
              <Col xs="10" className="mx-auto d-flex align-items-center">
                  <h5 className="m-0">Tankkaart</h5>
              </Col>
              <Col xs="2" className="d-flex justify-content-center">
                  <i className="far fa-credit-card fa-2x"></i>
              </Col>
          </Row>
          <Row className="mx-auto p-3 mb-3 button-row background-color-blue" onClick={() => history.push("/user-assets-overview")}>
              <Col xs="10" className="mx-auto d-flex align-items-center">
                  <h5 className="m-0">Werkmiddelen</h5>
              </Col>
              <Col xs="2" className="d-flex justify-content-center">
                  <i className="fas fa-laptop fa-2x"></i>
              </Col>
          </Row>

          
          {driver.companyCar.batteryCapacity > 0 && 
           <Row className="mx-auto p-3 mb-3 button-row background-color-blue" onClick={() => history.push("/user-charges")}>
           <Col xs="10" className="mx-auto d-flex align-items-center">
               <h5 className="m-0">Laadbeurten</h5>
           </Col>
           <Col xs="2" className="d-flex justify-content-center">
               <EvStationFill fontSize={32}/>
           </Col>
       </Row>}
         
      </div>
      }
            
            </>
        );
    }

    return (
        <>
            {getLoadSpinner()}
            <UserHeaderComponent headerText={"Persoonlijke gegevens"} />
            
            {getContent()}
            {getButtonDiv()}
        </>
    );
}